import styled from 'styled-components'
import { COLORS } from '../../constants'

export const Container = styled.div`
  display: flex;
  align-items: center;
  height: 7vh;
  background-color: ${COLORS.primary};
  padding: 0 1rem;
  cursor: pointer; /* Make the entire container clickable */

  > p {
    font-size: 1.3rem;
    color: white;
  }
`

export const StarWrapper = styled.div`
  display: flex;
  margin-left: 1rem;

  svg {
    cursor: pointer; /* Make the stars clickable */
    transition: color 0.3s ease;
  }
`
